import { useEffect, useState } from "react";
import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import axiosInstance from "../../api/axiosInstance.js";
import { useLocation, useNavigate } from "react-router-dom";
import Model from "../../common/Model/index.js";
import { saveAs } from "file-saver";
import Loader from "../../common/Loader/index.js";
import { notify, Toast } from "../../common/Toast/index.js";
import Select from "react-select";
import { FaStarOfLife } from "react-icons/fa";
import FormFields from "../../common/FormFields/index.js";
import { getUserMenuPermission } from "../../common/Helper/index.js";
import FinsMaterialItemTable from "./FinsMaterialItemTable.jsx";

const FinsMaterialDetails = () => {
  const today = new Date().toISOString()?.split("T")[0];
  const permission = getUserMenuPermission(18);
  const navigate = useNavigate();
  const location = useLocation();
  const { materialQuotationData = {} } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [terms, setTerms] = useState([]);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [salesPersons, setSalesPersons] = useState([]);
  const [coatingParties, setCoatingParties] = useState([]);
  const [coatingColors, setCoatingColors] = useState([]);
  const [coatingType, setCoatingType] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [allItems, setAllItems] = useState([]);
  const [isCoatingModalOpen, setIsCoatingModalOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [isItemModalOpen, setIsItemModalOpen] = useState(false);
  const [isSameAsBilling, setIsSameAsBilling] = useState(true);
  const [coatingPartyModel, setCoatingPartyModel] = useState(false);
  const [items, setItems] = useState([
    {
      seQ_NO: 1,
      itemId: "",
      item_Name: "",
      coating_Color_Id: "",
      panel_Size: 0,
      qty: 0,
      total_RFT: 0,
      rate: 0,
      coatingTypeId: 1,
      amount: 0,
    },
  ]);
  const [formData, setFormData] = useState({
    proforma_No: 0,
    proforma_Date: today,
    customer_Id: "",
    company_Id: 3,
    sale_Id: "",
    coating_Party_Id: "",
    shipping_Address: "",
    remark: "",
    project: "",
    gross_Amount: 0,
    disc_Per: 0,
    disc_Amount: 0,
    gsT_Per: 18,
    gsT_Amount: 0,
    transportation: 0,
    packing_Charge: 0,
    is_Urgent: false,
    net_Amount: "",
    stageId: null,
    reason: "",
  });
  const [isCoatingPartyEditing, setIsCoatingPartyEditing] = useState(false);

  const userId = localStorage.getItem("userId");
  const shouldShowCloseLostReason = (stageId) => {
    return stageId === 3;
  };
  const fields = [
    {
      name: "customer_Name",
      label: "Customer Name",
      type: "text",
      required: true,
      errorMessage: "Customer name is required",
    },
    { name: "mobile_No", label: "Contact No", type: "number" },
    { name: "firmName", label: "FirmName", type: "text" },
    { name: "address", label: " Address", type: "text" },
    { name: "gsT_No", label: "GST No", type: "text" },
  ];
  const CoatingPartyfields = [
    {
      name: "party_Name",
      label: "Party Name",
      type: "text",
      required: true,
      errorMessage: "Party name is required",
    },
    { name: "mobile_No", label: "Contact No", type: "number" },
    { name: "address", label: "Address", type: "text" },
    { name: "gsT_No", label: "GST No", type: "text" },
  ];

  useEffect(() => {
    if (
      materialQuotationData &&
      Object.keys(materialQuotationData).length > 0
    ) {
      setFormData((prev) => ({
        ...prev,
        proforma_No: materialQuotationData.proforma_No || 0,
        proforma_Date: materialQuotationData.proforma_Date,
        customer_Id: materialQuotationData.customer_Id || "",
        company_Id: materialQuotationData.company_Id || 3,
        sale_Id: materialQuotationData.sale_Id || "",
        coating_Party_Id: materialQuotationData.coating_Party_Id || "",
        shipping_Address: materialQuotationData.shipping_Address || "",
        remark: materialQuotationData.remark || "",
        project: materialQuotationData.project || "",
        gross_Amount: materialQuotationData.gross_Amount || "",
        disc_Per: materialQuotationData.disc_Per || 0,
        disc_Amount: materialQuotationData.disc_Amount || 0,
        gsT_Per: materialQuotationData.gsT_Per || 0,
        gsT_Amount: materialQuotationData.gsT_Amount ?? 0,
        transportation: materialQuotationData.transportation || 0,
        packing_Charge: materialQuotationData.packing_Charge || 0,
        net_Amount: materialQuotationData.net_Amount || 0,
        stageId: materialQuotationData.stage_Id || 0,
        reason: materialQuotationData.reason ?? "",
        is_Urgent: materialQuotationData.is_Urgent || false,
      }));

      const mapped = materialQuotationData.items.map((it, index) => ({
        seQ_NO: it.seQ_NO || index + 1,

        itemId: it.itemId,
        item_Name: it.item_Name,
        coating_Color_Id: it.coating_Color_Id,
        coatingTypeId: it.coatingTypeId,

        panel_Size: it.panel_Size,
        qty: it.qty,

        baseRate: it.actualRate ?? it.rate,
        rate: Number(it.rate),
        total_RFT: Number(it.total_RFT),
        amount: Number(it.amount),
      }));

      setItems(mapped);

      // setItems(materialQuotationData.items || []);
      setTerms(materialQuotationData.terms || []);
      setIsEditing(true);
    }
  }, [materialQuotationData, allItems, coatingType]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.customer_Id)
      newErrors.customer_Id = "Customer Name is required";
    if (!formData.sale_Id) newErrors.sale_Id = "Sale Person is required";
    if (!formData.proforma_Date)
      newErrors.proforma_Date = "Proforma Date is required";

    if (items.length === 0) {
      newErrors.items = "At least one item is required";
    } else {
      items.forEach((item, index) => {
        if (!item.itemId)
          newErrors[`item_Code_${index}`] = "Item Code is required";
        if (!item.qty || item.qty <= 0)
          newErrors[`qty_${index}`] = "Quantity must be greater than 0";
      });
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "proforma_No" ? parseInt(value, 10) || 0 : value,
    }));
  };

  const handleCoatingPartySubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        Party_Name: formData.party_Name,
        Mobile_No: formData.mobile_No,
        Address: formData.address,
        GST_No: formData.gsT_No,
        Is_Active: formData.is_Active ?? true,
      };

      const response = await axiosInstance.post(
        "MaterialQuotation/SaveCoatingParty",
        payload
      );

      notify("Coating Party added successfully!", "success");
      fetchDropdownData("Coating/GetAllCoatingParties", setCoatingParties);
      if (response?.data?.coating_Party_Id) {
        setFormData((prev) => ({
          ...prev,
          coating_Party_Id: response.data.coating_Party_Id,
        }));
      }

      setCoatingPartyModel(false);
    } catch (err) {
      console.error("Error saving coating party:", err);
      notify("Failed to add Coating Party", "error");
    }
  };

  const handleCustomerChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData((prev) => ({
        ...prev,
        customer_Id: "",
        shipping_Address: "",
      }));
      setIsSameAsBilling(false);
      return;
    }

    const customerId = selectedOption.value;
    if (customerId === "add-new") {
      setFormData({
        customer_Name: "",
        mobile_No: "",
        firmName: "",
        address: "",
        gsT_No: "",
        customer_Id: "",
        shipping_Address: "",
      });
      setIsSameAsBilling(false);
      setIsModelOpen(true);
      return;
    }

    const customer = customers.find(
      (c) => c.customer_Id === Number(customerId)
    );
    const address = customer?.address || "";
    setFormData((prev) => ({
      ...prev,
      customer_Id: Number(customerId),
      shipping_Address: address,
    }));
    setIsSameAsBilling(true);
  };
  const handleSameAsBillingChange = () => {
    const selectedCustomer = customers.find(
      (c) => c.customer_Id === Number(formData.customer_Id)
    );

    const address = selectedCustomer?.address || "";

    setIsSameAsBilling((prev) => {
      const newValue = !prev;
      if (newValue) {
        setFormData((prevForm) => ({
          ...prevForm,
          shipping_Address: address,
        }));
      }
      return newValue;
    });
  };

  useEffect(() => {
    fetchDropdownData("Customer/GetAll", setCustomers);
    fetchDropdownData("User/GetAllUser ", setSalesPersons);
    fetchDropdownData(
      "MaterialQuotation/GetAllCoatingParties",
      setCoatingParties
    );
    fetchDropdownData(
      "MaterialQuotation/GetAllCoatingColors",
      setCoatingColors
    );
    fetchDropdownData("CoatingType/GetAll", setCoatingType);
    fetchItemsData();
    if (
      materialQuotationData &&
      Object.keys(materialQuotationData).length > 0
    ) {
      fetchTermsData(
        materialQuotationData.proforma_No,
        materialQuotationData.terms
      );
    } else {
      fetchTermsData(0);
    }
  }, []);

  const fetchTermsData = async (proforma_No = 0, existingTerms = []) => {
    try {
      setLoading(true);

      if (proforma_No === 0) {
        const response = await axiosInstance.get("Terms/GetAll");
        const formattedTerms = response.data.map((term, index) => ({
          seq_No: index + 1,
          term_Name: term.term_Name,
          term_Id: term.term_Id,
          isEditing: false,
        }));
        setTerms(formattedTerms);
      } else {
        setTerms(existingTerms || []);
      }
    } catch (error) {
      console.error("Error fetching terms:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchItemsData = async () => {
    try {
      const response = await axiosInstance.get("FinsItem/GetAll");
      setAllItems(response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  const num = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };
  const totalAmountBeforeTax = items.reduce(
    (sum, item) => sum + (item.amount || 0),
    0
  );

  const discount =
    (Number(totalAmountBeforeTax) * (parseFloat(formData.disc_Per) || 0)) / 100;

  const total =
    totalAmountBeforeTax -
    discount +
    num(formData.transportation) +
    num(formData.packing_Charge);

  const gstAmount = (total * (parseFloat(formData.gsT_Per) || 0)) / 100;

  const grandTotal = total + gstAmount;



  const calcRft = (row) => {
    const panel = num(row.panel_Size);
    const qty = num(row.qty);
    return panel > 0 ? (panel * qty) / 304.8 : qty;
  };

  const findItem = (all, id) =>
    all?.find((it) => String(it.itemId) === String(id));

  const getItemBaseRate = (all, id) => {
    const it = findItem(all, id);
    return num(it?.rate ?? it?.item_Rate);
  };

  const getAddPer = (coatingType, id) => {
    const t = coatingType?.find(
      (ct) => String(ct.coatingTypeId) === String(id)
    );
    return num(t?.addPer);
  };

  const calcFinalRate = (baseRate, coatingTypeId) => {
    const addPer = getAddPer(coatingType, coatingTypeId);
    return num(baseRate) * (1 + addPer / 100);
  };

  const round2 = (v) => Math.round(Number(v) * 100) / 100;

  const recalcRow = (row) => {
    const rftRaw = calcRft(row);
    const total_RFT = round2(rftRaw);
    const rateVal = num(row.rate);
    const amount = round2(total_RFT * rateVal);

    return {
      ...row,
      total_RFT,
      amount,
    };
  };

  const handleItemSelect = (index, eventOrOption, fieldName = null) => {
    const updated = [...items];

    const getValue = () =>
      eventOrOption?.target?.value !== undefined
        ? eventOrOption.target.value
        : eventOrOption?.value;

    const setField = (row, key, value) => ({ ...row, [key]: value });

    if (fieldName && eventOrOption === null) {
      if (fieldName === "itemId") {
        updated[index] = recalcRow({
          ...updated[index],
          itemId: "",
          item_Name: "",
          baseRate: 0,
          coatingTypeId: "",
          coating_Color_Id: "",
          rate: 0,
          qty: 0,
          panel_Size: 0,
          total_RFT: 0,
          amount: 0,
        });
        setItems(updated);
        return;
      }

      if (name === "coatingTypeId") {
        const base = num(updated[index].baseRate);
        const finalRate = calcFinalRate(base, value);

        updated[index] = recalcRow({
          ...updated[index],
          coatingTypeId: value,
          rate: round2(finalRate),
        });

        setItems(updated);
        return;
      }

      updated[index] = recalcRow(setField(updated[index], fieldName, ""));
      setItems(updated);
      return;
    }

    const value = fieldName ? getValue() : eventOrOption.target.value;
    const name = fieldName ? fieldName : eventOrOption.target.name;

    if (name === "coating_Color_Id" && value === "add-new") {
      if (!formData.coating_Party_Id) {
        notify(
          "Please select a Coating Party before adding a new Coating Color",
          "error"
        );
        return;
      }
      setIsCoatingModalOpen(true);
      return;
    }

    if (name === "itemId" && value === "add-newItem") {
      setIsItemModalOpen(true);
      return;
    }

    if (name === "itemId") {
      const selectedItem = findItem(allItems, value);
      if (!selectedItem) return;

      const base = num(selectedItem.rate ?? selectedItem.item_Rate);
      const coatingTypeId = updated[index].coatingTypeId;

      const finalRate = coatingTypeId
        ? calcFinalRate(base, coatingTypeId)
        : base;

      updated[index] = recalcRow({
        ...updated[index],
        itemId: selectedItem.itemId || "",
        item_Name: selectedItem.itemName || selectedItem.item_Name || "",
        baseRate: base,
        rate: finalRate,
      });

      setItems(updated);
      return;
    }

    if (name === "coatingTypeId") {
      const coatingTypeId = value || "";
      const base =
        num(updated[index].baseRate) ||
        getItemBaseRate(allItems, updated[index].itemId);

      const finalRate = coatingTypeId
        ? calcFinalRate(base, coatingTypeId)
        : base;

      updated[index] = recalcRow({
        ...updated[index],
        coatingTypeId,
        baseRate: base,
        rate: round2(finalRate),
      });

      setItems(updated);
      return;
    }

    if (name === "rate") {
      updated[index] = recalcRow({
        ...updated[index],
        rate: value,
      });
      setItems(updated);
      return;
    }

    updated[index] = recalcRow(setField(updated[index], name, value));

    setItems(updated);
  };

  const handleItemDelete = async (rowIndex) => {
    const proforma_No = Number(formData.proforma_No || 0);
    const row = items[rowIndex];
    const isPersisted = proforma_No > 0 && Number(row?.seQ_NO) > 0;
    if (isPersisted) {
      try {
        await axiosInstance.delete(
          `FinsMaterialQuotations/DeleteItem/${proforma_No}/${row.seQ_NO}`
        );
        notify("Item deleted successfully", "success");
      } catch (error) {
        console.error("Error deleting item:", error);
        notify(
          error?.response?.data?.message || "Error deleting item",
          "error"
        );
        return;
      }
    }
    setItems((prev) =>
      prev
        .filter((_, i) => i !== rowIndex)
        .map((it, i) => ({ ...it, seQ_NO: i + 1 }))
    );
  };

  const fetchDropdownData = async (endpoint, setData, dataKey) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(endpoint);
      if (dataKey) {
        setData(response.data[dataKey] || []);
      } else {
        setData(response.data || []);
      }
    } catch (error) {
      console.error(`Error fetching data from ${endpoint}:`, error);
    } finally {
      setLoading(false);
    }
  };
  const handleAddTerm = () => {
    setTerms((prevTerms) => {
      if (formData.proforma_No === 0) {
        const newTermId =
          prevTerms.length > 0
            ? prevTerms[prevTerms.length - 1].term_Id + 1
            : 1;
        return [
          ...prevTerms,
          { term_Id: newTermId, term_Name: "", isEditing: true },
        ];
      } else {
        const newSeqNo =
          prevTerms.length > 0 ? prevTerms[prevTerms.length - 1].seq_No + 1 : 1;
        return [
          ...prevTerms,
          { seq_No: newSeqNo, term_Name: "", isEditing: true, isNew: true },
        ];
      }
    });
  };

  const handleEditTerms = (id) => {
    setTerms((prevTerms) =>
      prevTerms.map((term) =>
        (formData.proforma_No === 0 ? term.term_Id : term.seq_No) === id
          ? { ...term, isEditing: true }
          : term
      )
    );
  };
  const handleDeleteTerm = async (seq_No, isNew) => {
    const proforma_No = formData.proforma_No;
    if (proforma_No === 0) {
      setTerms((prevTerms) =>
        prevTerms.filter((term) => term.term_Id !== seq_No)
      );
    } else {
      if (isNew === true) {
        setTerms((prevTerms) =>
          prevTerms.filter((term) => term.seq_No !== seq_No)
        );
        return;
      }
      try {
        await axiosInstance.delete(
          `FinsMaterialQuotations/DeleteTerm/${proforma_No}/${seq_No}`
        );
        setTerms((prevTerms) =>
          prevTerms.filter((term) => term.seq_No !== seq_No)
        );
      } catch (error) {
        console.error("Error deleting term:", error);
      }
    }
  };

  const handleTermChange = (index, event) => {
    const { name, value } = event.target;
    setTerms((prevTerms) =>
      prevTerms.map((term, i) =>
        i === index ? { ...term, [name]: value } : term
      )
    );
  };

  const handleSaveOrUpdate = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    const payload = {
      Proforma_No: Number(formData.proforma_No) || 0,
      Customer_Id: Number(formData.customer_Id),
      Company_Id: formData.company_Id || 3,
      Sale_Id: Number(formData.sale_Id),
      Coating_Party_Id: Number(formData.coating_Party_Id),
      shipping_Address: formData.shipping_Address,
      remark: formData.remark,
      project: formData.project,
      Proforma_Date: formData.proforma_Date,
      Modified_By: Number(formData.modifiedBy) || 0,
      Gross_Amount: Number(totalAmountBeforeTax),
      Disc_Per: Number(formData.disc_Per),
      Disc_Amount: Number(discount),
      GST_Per: Number(formData.gsT_Per),
      GST_Amount: Number(gstAmount),
      Transportation: Number(formData.transportation),
      Packing_Charge: Number(formData.packing_Charge),
      Net_Amount: Number(grandTotal),
      Is_Urgent: formData.is_Urgent || false,
      CreatedBy: userId,
      ...(Number(formData.stageId) === 3 && {
        Reason: formData.reason,
      }),

      Items: items.map((item) => ({
        itemId: Number(item.itemId),
        Coating_Color_Id:
          item.coating_Color_Id && !isNaN(item.coating_Color_Id)
            ? parseInt(item.coating_Color_Id)
            : null,
        Qty: Number(item.qty) || 0,
        Panel_size: item.panel_Size || 0,
        coatingTypeId: item.coatingTypeId,
        total_RFT: Number(item.total_RFT),
        Rate: Number(item.rate),
        Amount: item.amount,
        seQ_NO: item.seQ_NO,
      })),
      Terms: terms.map((term) => ({
        seq_No: Number(formData.proforma_No) > 0 ? Number(term.seq_No) : 0,
        Term_Name: term.term_Name,
        Proforma_No: Number(formData.proforma_No),
      })),
    };

    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "FinsMaterialQuotations/SaveOrUpdate",
        payload
      );

      if (response?.data) {
        notify(
          isEditing
            ? "Fins Quotation updated successfully!"
            : "Fins Quotation added successfully!",
          "success"
        );
        setTimeout(() => navigate("/quotes/fins-quotation"), 1000);
      } else {
        notify("Something went wrong. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error saving quotation:", error);
      notify("Failed to save Fins Quotation.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        Customer_Name: formData.customer_Name,
        Firm_Name: formData.firmName,
        Mobile_No: formData.mobile_No,
        Address: formData.address,
        GST_No: formData.gsT_No,
      };

      await axiosInstance.post("Customer/SaveOrUpdate", payload);
      fetchDropdownData("Customer/GetAll", setCustomers);
      setIsModelOpen(false);
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };

  const onClear = () => {
    setIsModelOpen(false);
  };

  const handlePrint = async (proforma_No) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `FinsMaterialQuotations/FinsQuotePrint/${proforma_No}`,
        { responseType: "blob" }
      );

      if (response.status === 200) {
        const blob = new Blob([response.data], { type: "application/pdf" });

        const customer = customers.find(
          (c) => c.customer_Id === Number(formData.customer_Id)
        );
        const customerName =
          customer?.customer_Name?.replace(/\s+/g, "_") || "Customer";

        saveAs(blob, `PI_${proforma_No}_${customerName}.pdf`);

        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      } else {
        alert("Failed to generate PDF. Please try again later.");
      }
    } catch (error) {
      console.error("Error printing Fins Quotation:", error);
      const errorMessage =
        error.response?.data?.message || "Unknown error occurred.";

      if (errorMessage.includes("Select.HtmlToPdf")) {
        alert(
          "PDF generation is currently unavailable. Please contact support."
        );
      } else {
        alert(`An error occurred while printing: ${errorMessage}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const options = [
    ...customers.map((cus) => ({
      value: cus.customer_Id?.toString() || "",
      label: cus.customer_Name || "Unnamed Customer",
    })),
    { value: "add-new", label: "+ Add New Customer" },
  ];
  const saleOptions = [
    ...salesPersons.map((per) => ({
      value: per.sale_Person_Id?.toString() || "",
      label: per.Sale_Person_Name || "Unnamed Sales",
    })),
  ];
  const coatingOptions = [
    ...coatingParties.map((coat) => ({
      value: coat.coating_Party_Id?.toString() || "",
      label: coat.party_Name || "Unnamed Coating",
    })),
    { value: "add-newCoatingParty", label: "+ Add New Coating Party" },
  ];

  const premiumSelectStyles = (error = false) => ({
    control: (base, state) => ({
      ...base,
      borderRadius: "0.75rem",
      padding: "0.125rem 0.5rem",
      border: error ? "1px solid #fda4af" : state.isFocused ? "1.5px solid #405189" : "1.5px solid #e2e8f0",
      backgroundColor: error ? "#fff1f2" : "white",
      boxShadow: state.isFocused ? "0 0 0 4px rgba(64, 81, 137, 0.05)" : "none",
      transition: "all 0.2s ease",
      minHeight: "42px",
      "&:hover": { borderColor: state.isFocused ? "#405189" : "#cbd5e1" },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999999 }),
    menu: (base) => ({
      ...base,
      borderRadius: "1rem",
      overflow: "hidden",
      boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
      border: "1px solid #f1f5f9",
      padding: "4px",
      zIndex: 9999999,
    }),
    option: (base, state) => ({
      ...base,
      borderRadius: "0.5rem",
      backgroundColor: state.isSelected ? "#405189" : state.isFocused ? "#f8fafc" : "transparent",
      color: state.isSelected ? "white" : "#475569",
      padding: "8px 12px",
      fontWeight: state.isSelected ? "700" : "500",
      fontSize: "0.813rem",
      cursor: "pointer",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#94a3b8",
      fontSize: "0.813rem",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#1e293b",
      fontWeight: "600",
      fontSize: "0.813rem",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isFocused ? "#405189" : "#cbd5e1",
      padding: "2px",
    }),
  });

  const handleCoatingPartyEdit = async (id) => {
    try {
      const { data } = await axiosInstance.get(
        `MaterialQuotation/GetCoatingPartyById/${id}`
      );
      setFormData((prev) => ({
        ...prev,
        ...data,
        coating_Party_Id: Number(id),
      }));
      setIsCoatingPartyEditing(true);
      setCoatingPartyModel(true);
    } catch (err) {
      console.error(err);
    }
  };
  const handleUpdateCoatingParty = async () => {
    try {
      await axiosInstance.post("MaterialQuotation/UpdateCoatingParty", {
        Coating_Party_Id: formData.coating_Party_Id,
        Party_Name: formData.party_Name,
        Mobile_No: formData.mobile_No,
        Address: formData.address,
        Gst_No: formData.gsT_No,
      });

      notify("Coating Party Updated Successfully!", "success");
      fetchDropdownData("Coating/GetAllCoatingParties", setCoatingParties);
      setCoatingPartyModel(false);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Toast />
      <div>
        {loading ? (
          <div className="flex items-center justify-center min-h-[60vh]">
            <Loader />
          </div>
        ) : (
          <div>
            {/* Header section */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 gap-4">
              <div className="flex flex-col">
                <div className="flex items-center gap-2 mb-0.5">
                  <h1 className="text-xl font-black text-slate-800 tracking-tight uppercase">Fins Details</h1>
                  {formData.is_Urgent && (
                    <span className="px-2 py-0.5 bg-red-50 text-red-500 text-[9px] font-black uppercase tracking-widest rounded-full border border-red-100 animate-pulse">
                      Urgent Case
                    </span>
                  )}
                </div>
                <p className="text-[11px] text-slate-400 font-bold uppercase tracking-wider">Manage fins proforma invoice and tracking</p>
              </div>
              <button
                className="px-4 py-2 bg-white hover:bg-slate-50 text-slate-700 text-[11px] font-black uppercase tracking-widest rounded-xl border border-slate-200 shadow-sm transition-all flex items-center gap-2 active:scale-95"
                onClick={() => navigate(`/quotes/fins-quotation`)}
              >
                <span className="text-lg">←</span> Back to List
              </button>
            </div>

            <form className="space-y-4" onSubmit={handleSaveOrUpdate}>
              {/* Primary Attributes Card */}
              <div className="bg-white p-6 rounded-3xl shadow-xl shadow-slate-200/40 border border-slate-100 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary/40 to-primary"></div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                  <div className="flex flex-col space-y-2">
                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1 flex items-center">
                      Proforma No
                    </label>
                    <input
                      type="text"
                      name="proforma_No"
                      value={formData.proforma_No}
                      disabled
                      className="w-full rounded-xl border border-slate-100 bg-slate-50/50 px-4 py-2 text-slate-400 font-black cursor-not-allowed text-xs"
                    />
                  </div>

                  <div className="flex flex-col space-y-2">
                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1 flex items-center">
                      Proforma Date
                      <FaStarOfLife className="text-red-400 ml-2 w-1.5 h-1.5" />
                    </label>
                    <input
                      name="proforma_Date"
                      type="date"
                      value={formData.proforma_Date?.split("T")[0]}
                      onChange={handleInputChange}
                      className={`w-full rounded-xl border px-4 py-[8px] outline-none transition-all duration-300 font-black text-xs ${errors.proforma_Date
                        ? "border-red-300 bg-red-50/20"
                        : "border-slate-200 bg-white hover:border-primary/30 focus:border-primary"
                        }`}
                    />
                    {errors.proforma_Date && (
                      <p className="text-red-500 text-[10px] font-black mt-1 ml-1 uppercase">{errors.proforma_Date}</p>
                    )}
                  </div>

                  <div className="flex flex-col space-y-2">
                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1 flex items-center">
                      Customer Name
                      <FaStarOfLife className="text-red-400 ml-2 w-1.5 h-1.5" />
                    </label>
                    <Select
                      options={options}
                      value={options.find((option) => Number(option.value) === Number(formData.customer_Id)) || null}
                      isClearable
                      isSearchable
                      onChange={handleCustomerChange}
                      menuPortalTarget={document.body}
                      styles={premiumSelectStyles(errors.customer_Id)}
                    />
                    {errors.customer_Id && (
                      <p className="text-red-500 text-[10px] font-black mt-1 ml-1 uppercase">{errors.customer_Id}</p>
                    )}
                  </div>

                  <div className="flex flex-col space-y-2">
                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1 flex items-center">
                      Sales Person
                      <FaStarOfLife className="text-red-400 ml-2 w-1.5 h-1.5" />
                    </label>
                    <Select
                      options={saleOptions}
                      value={saleOptions.find((option) => Number(option.value) === Number(formData.sale_Id)) || null}
                      isClearable
                      isSearchable
                      menuPortalTarget={document.body}
                      onChange={(option) => setFormData((prev) => ({ ...prev, sale_Id: option ? option.value : "" }))}
                      styles={premiumSelectStyles(errors.sale_Id)}
                    />
                    {errors.sale_Id && (
                      <p className="text-red-500 text-[10px] font-black mt-1 ml-1 uppercase">{errors.sale_Id}</p>
                    )}
                  </div>
                </div>
              </div>

              {/* Delivery & Documentation Card */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div className="bg-white p-6 rounded-3xl shadow-xl shadow-slate-200/40 border border-slate-100 relative overflow-hidden h-full">
                  <h3 className="text-[11px] font-black text-primary uppercase tracking-[0.2em] mb-4 flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary/40 animate-pulse"></div>
                    Delivery & Location Info
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="flex flex-col space-y-2">
                      <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                        Coating Party
                      </label>
                      <div className="flex gap-2 items-center">
                        <div className="flex-1">
                          <Select
                            options={coatingOptions}
                            value={coatingOptions.find((option) => Number(option.value) === Number(formData.coating_Party_Id)) || null}
                            isClearable
                            isSearchable
                            onChange={(option) => {
                              if (option?.value === "add-newCoatingParty") {
                                setFormData((prev) => ({ ...prev, party_Name: "", mobile_No: "", address: "", gsT_No: "" }));
                                setCoatingPartyModel(true);
                              } else {
                                setFormData((prev) => ({ ...prev, coating_Party_Id: option ? option.value : "" }));
                              }
                            }}
                            menuPortalTarget={document.body}
                            styles={premiumSelectStyles()}
                          />
                        </div>
                        {formData.coating_Party_Id && (
                          <button
                            type="button"
                            className="p-2.5 bg-primary/5 text-primary rounded-xl hover:bg-primary hover:text-white transition-all shadow-sm flex-shrink-0"
                            onClick={() => handleCoatingPartyEdit(formData.coating_Party_Id)}
                          >
                            <MdModeEdit size={16} />
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="flex flex-col space-y-2">
                      <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                        Project Reference
                      </label>
                      <input
                        type="text"
                        value={formData.project}
                        onChange={handleInputChange}
                        name="project"
                        placeholder="Enter project name..."
                        className="w-full rounded-xl border border-slate-200 bg-white px-4 py-2 text-slate-600 font-bold text-xs outline-none focus:border-primary transition-all"
                      />
                    </div>

                    <div className="flex items-center h-full pt-2">
                      <label className={`flex items-center gap-3 bg-slate-50/50 px-4 py-2 rounded-xl border border-slate-100 group transition-all w-full ${[1, 19].includes(Number(userId)) ? "cursor-pointer hover:bg-white" : "cursor-not-allowed opacity-60"}`}>
                        <div className="relative inline-flex items-center">
                          <input
                            type="checkbox"
                            id="id_Urgent"
                            checked={formData.is_Urgent}
                            disabled={![1, 19].includes(Number(userId))}
                            onChange={(e) => setFormData(prev => ({ ...prev, is_Urgent: e.target.checked }))}
                            className="sr-only peer"
                          />
                          <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-red-500 shadow-sm transition-all"></div>
                        </div>
                        <span className={`text-[10px] font-black uppercase tracking-widest ${formData.is_Urgent ? "text-red-500" : "text-slate-400"}`}>
                          Flag as Urgent
                        </span>
                      </label>
                    </div>

                    <div className="flex flex-col space-y-2">
                      <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                        Company Name
                      </label>
                      <input
                        type="text"
                        value="H-LINE"
                        disabled
                        name="company_Id"
                        className="w-full rounded-xl border border-slate-100 bg-slate-50/50 px-4 py-2.5 text-slate-400 font-black cursor-not-allowed text-xs"
                      />
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-3xl shadow-xl shadow-slate-200/40 border border-slate-100">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-[11px] font-black text-primary uppercase tracking-[0.2em] flex items-center gap-2">
                      <div className="w-1.5 h-1.5 rounded-full bg-primary/40 animate-pulse"></div>
                      Address Details
                    </h3>
                    <label className="relative inline-flex items-center cursor-pointer group">
                      <input
                        id="isSameAsBilling"
                        type="checkbox"
                        className="sr-only peer"
                        checked={isSameAsBilling}
                        onChange={handleSameAsBillingChange}
                      />
                      <div className="w-9 h-5 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primary"></div>
                      <span className="ml-2 text-[10px] font-black uppercase tracking-widest text-slate-400 group-hover:text-primary transition-colors">Same as Billing</span>
                    </label>
                  </div>

                  <div className="grid grid-cols-1 gap-4">
                    <div className="flex flex-col space-y-2">
                      <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                        Shipping Address
                      </label>
                      <textarea
                        rows={3}
                        className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 outline-none transition-all hover:border-primary/30 focus:border-primary font-bold text-xs leading-relaxed disabled:bg-slate-50 disabled:text-slate-400"
                        value={formData.shipping_Address}
                        onChange={(e) => {
                          setFormData(prev => ({ ...prev, shipping_Address: e.target.value }));
                          setIsSameAsBilling(false);
                        }}
                        disabled={isSameAsBilling}
                        placeholder="Complete delivery address..."
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-1">
                <FinsMaterialItemTable
                  items={items}
                  setItems={setItems}
                  allItems={allItems}
                  setAllItems={setAllItems}
                  coatingColors={coatingColors}
                  setCoatingColors={setCoatingColors}
                  setCoatingType={setCoatingType}
                  coatingType={coatingType}
                  handleItemSelect={handleItemSelect}
                  handleItemDelete={handleItemDelete}
                  selectedCoatingPartyId={formData.coating_Party_Id}
                  isCoatingModalOpen={isCoatingModalOpen}
                  setIsCoatingModalOpen={setIsCoatingModalOpen}
                  setIsItemModalOpen={setIsItemModalOpen}
                  isItemModalOpen={isItemModalOpen}
                  errors={errors}
                  validateForm={validateForm}
                  isEditing={isEditing}
                  fetchDropdownData={fetchDropdownData}
                  permission={permission}
                />
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {/* Terms Card */}
                <div className="bg-white rounded-3xl shadow-xl shadow-slate-200/30 border border-slate-100 overflow-hidden flex flex-col">
                  <div className="bg-slate-50/50 px-6 py-3 border-b border-slate-100 flex justify-between items-center">
                    <h2 className="text-[10px] font-black text-slate-700 uppercase tracking-[0.2em]">General Terms</h2>
                    <button
                      type="button"
                      className="text-[9px] font-black text-primary bg-primary/10 px-3 py-1 rounded-full hover:bg-primary hover:text-white transition-all uppercase tracking-widest"
                      onClick={handleAddTerm}
                    >
                      + ADD NEW
                    </button>
                  </div>
                  <div className="p-4 space-y-2 max-h-[300px] overflow-y-auto">
                    {terms?.length === 0 && (
                      <div className="flex flex-col items-center justify-center py-6 text-slate-300">
                        <p className="text-[10px] font-black uppercase tracking-widest">No terms defined</p>
                      </div>
                    )}
                    {terms.map((term, index) => (
                      <div key={index} className="flex items-center gap-3 bg-slate-50/50 rounded-xl p-1 border border-slate-100 group transition-all hover:bg-white hover:shadow-sm">
                        <textarea
                          name="term_Name"
                          value={term.term_Name || ""}
                          onChange={(e) => handleTermChange(index, e)}
                          disabled={!term.isEditing}
                          rows={1}
                          className={`flex-grow bg-transparent text-[12px] font-bold leading-normal outline-none transition-all resize-none ${term.isEditing ? "text-primary border-b border-primary/20" : "text-slate-600"}`}
                          placeholder="Type term..."
                        />
                        <div className="flex gap-1.5 opacity-0 group-hover:opacity-100 transition-opacity">
                          <button
                            type="button"
                            className={`p-1.5 rounded-lg transition-all ${term.isEditing ? "bg-primary text-white" : "bg-white text-slate-400 hover:text-primary border border-slate-100"}`}
                            onClick={() => handleEditTerms(formData.proforma_No === 0 ? term.term_Id : term.seq_No)}
                          >
                            <MdModeEdit size={14} />
                          </button>
                          <button
                            type="button"
                            className="p-1.5 bg-white text-slate-400 hover:text-red-500 rounded-lg border border-slate-100 transition-all"
                            onClick={() => handleDeleteTerm(formData.proforma_No === 0 ? term.term_Id : term.seq_No, term.isNew)}
                          >
                            <MdDeleteForever size={14} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Financial Summary Card */}
                <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col">
                  <div className="bg-[#f4f7fd] px-6 py-4 border-b border-slate-200">
                    <h2 className="text-sm font-bold text-[#405189]">Account List</h2>
                  </div>
                  <div className="p-6 space-y-4">
                    {/* Row: Subtotal */}
                    <div className="flex justify-between items-center text-[#495057]">
                      <span className="text-sm font-medium">Total Amount Before Tax:</span>
                      <span className="text-sm font-bold">₹{totalAmountBeforeTax?.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                    </div>

                    {/* Row: Discount */}
                    <div className="flex justify-between items-center text-[#495057]">
                      <span className="text-sm font-medium">Discount (%):</span>
                      <div className="flex items-center gap-2">
                        <input
                          type="text"
                          value={formData.disc_Per}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === "" || /^\d*\.?\d*$/.test(val)) setFormData(prev => ({ ...prev, disc_Per: val }));
                          }}
                          className="w-24 bg-white border border-slate-200 rounded-lg px-3 py-1.5 text-right font-medium text-[#495057] focus:border-[#405189] outline-none text-sm"
                          placeholder="0"
                        />
                        <span className="text-[#495057] font-medium">= ₹{discount?.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                      </div>
                    </div>

                    {/* Row: Transportation */}
                    <div className="flex justify-between items-center text-[#495057]">
                      <span className="text-sm font-medium">Transportation:</span>
                      <input
                        type="text"
                        name="transportation"
                        value={formData.transportation}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === "" || /^\d*\.?\d*$/.test(val)) handleInputChange(e);
                        }}
                        className="w-24 bg-white border border-slate-200 rounded-lg px-3 py-1.5 text-right font-medium text-[#495057] focus:border-[#405189] outline-none text-sm"
                        placeholder="0"
                      />
                    </div>

                    {/* Row: Packing Charge */}
                    <div className="flex justify-between items-center text-[#495057]">
                      <span className="text-sm font-medium">Packing Charge:</span>
                      <input
                        type="text"
                        name="packing_Charge"
                        value={formData.packing_Charge}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === "" || /^\d*\.?\d*$/.test(val)) handleInputChange(e);
                        }}
                        className="w-24 bg-white border border-slate-200 rounded-lg px-3 py-1.5 text-right font-medium text-[#495057] focus:border-[#405189] outline-none text-sm"
                        placeholder="0"
                      />
                    </div>

                    {/* Row: Total After Deductions */}
                    <div className="flex justify-between items-center text-[#495057] pt-2">
                      <span className="text-sm font-medium">Total:</span>
                      <span className="text-sm font-bold">₹{total?.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                    </div>

                    {/* Row: GST */}
                    <div className="flex justify-between items-center text-[#495057]">
                      <span className="text-sm font-medium">GST (%):</span>
                      <div className="flex items-center gap-2">
                        <input
                          type="text"
                          value={formData.gsT_Per}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === "" || /^\d*\.?\d*$/.test(val)) setFormData(prev => ({ ...prev, gsT_Per: val }));
                          }}
                          className="w-24 bg-white border border-slate-200 rounded-lg px-3 py-1.5 text-right font-medium text-[#495057] focus:border-[#405189] outline-none text-sm"
                          placeholder="18"
                        />
                        <span className="text-[#495057] font-medium">= ₹{gstAmount?.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                      </div>
                    </div>

                    <div className="h-px bg-slate-100 my-4" />

                    {/* Final Grand Total */}
                    <div className="flex justify-between items-center pt-2">
                      <span className="text-lg font-bold text-[#405189]">Grand Total:</span>
                      <span className="text-xl font-bold text-[#405189]">₹{grandTotal?.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Remarks/Reasons and Action Buttons */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div className="bg-white rounded-3xl shadow-xl shadow-slate-200/30 border border-slate-100 p-6">
                  <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-3">Internal Remarks</h3>
                  <textarea
                    id="remark"
                    rows="3"
                    name="remark"
                    value={formData.remark}
                    onChange={handleInputChange}
                    className="w-full rounded-xl border border-slate-100 bg-slate-50/30 px-4 py-3 outline-none focus:border-primary transition-all font-black text-xs"
                    placeholder="Significant notes or instructions..."
                  />
                </div>

                <div className="flex items-end justify-end gap-3 pb-2">
                  <button
                    type="button"
                    className="px-6 py-2.5 bg-slate-100 text-slate-500 text-[10px] font-black uppercase tracking-widest rounded-xl hover:bg-slate-200 transition-all active:scale-[0.95]"
                    onClick={() => navigate(-1)}
                  >
                    Discard Changes
                  </button>



                  {(isEditing ? permission.isUpdate : permission.isInsert) && (
                    <button
                      className="px-8 py-2.5 bg-primary text-white text-[10px] font-black uppercase tracking-widest rounded-xl shadow-md shadow-primary/20 hover:-translate-y-0.5 transition-all active:scale-[0.95] flex items-center gap-2"
                      type="submit"
                    >
                      <span>{isEditing ? "Update proforma" : "Save proforma"}</span>
                      <span className="text-sm">→</span>
                    </button>
                  )}
                  {isEditing && (
                    <button
                      type="button"
                      className="px-6 py-2.5 bg-white border border-slate-200 text-slate-700 text-[10px] font-black uppercase tracking-widest rounded-xl hover:bg-slate-50 transition-all active:scale-[0.95] flex items-center gap-2 shadow-sm"
                      onClick={() => handlePrint(formData.proforma_No)}
                    >
                      <span className="text-sm text-primary">⎙</span>
                      <span>Print</span>
                    </button>
                  )}
                </div>
              </div>
            </form>

            {/* Modals */}
            <Model isOpen={isModelOpen} onClose={() => setIsModelOpen(false)} name="Add Customer">
              <FormFields
                onSubmit={handleSubmit}
                setIsModelOpen={setIsModelOpen}
                formData={formData}
                handleInputChange={handleInputChange}
                fields={fields}
                onClear={onClear}
              />
            </Model>
            <Model
              isOpen={coatingPartyModel}
              onClose={() => {
                setCoatingPartyModel(false);
                setIsCoatingPartyEditing(false);
              }}
              name={isEditing ? "Edit Coating Party" : "Add Coating Party"}
            >
              <FormFields
                formData={formData}
                fields={CoatingPartyfields}
                handleInputChange={handleInputChange}
                setIsModelOpen={setCoatingPartyModel}
                onClear={() => {
                  setCoatingPartyModel(false);
                  setIsCoatingPartyEditing(false);
                }}
                onSubmit={isCoatingPartyEditing ? handleUpdateCoatingParty : handleCoatingPartySubmit}
                isEditing={isCoatingPartyEditing}
              />
            </Model>
          </div>
        )}
      </div>
    </>
  );
};

export default FinsMaterialDetails;
